import { useFetch } from "../../api/useFetch";
import { ZoomData } from "./types";

export const useZoom = () => {
    return useFetch<ZoomData | null>(null, {url: '/lectureroom'});
}